'use client';
import {
  CatInlineNotification,
  CatIconInfo,
  CatHeading
} from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { sendGAInvalidSerialWithSites } from '../../../utils';
import { useFormSubmitEvent } from 'hooks/analytics/use-form-submit-event';
import styles from './non-cat-equipment-banner-client.module.scss';

export const NonCatEquipmentBannerClient = ({ appName, children }) => {
  const t = useTranslations();
  const { fireEvent } = useFormSubmitEvent();

  useEffect(() => {
    sendGAInvalidSerialWithSites(appName, fireEvent);
  }, [fireEvent, appName]);
  return (
    <div className={`${styles['inline-notification']} pt-2 mt-1`}>
      <CatInlineNotification dismissible={true}>
        <CatIconInfo slot="before" />
        <CatHeading variant="label">{t('SN_NOT_SUPPORTED_ERROR')}</CatHeading>
        {children}
      </CatInlineNotification>
    </div>
  );
};
export default NonCatEquipmentBannerClient;
